'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        replace('/login');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireLogin },
      _react2.default.createElement(_reactRouter.Route, { path: 'chat', component: _containers.Chat }),
      _react2.default.createElement(_reactRouter.Route, { path: 'loginSuccess', component: _containers.LoginSuccess }),
      _react2.default.createElement(_reactRouter.Route, { path: 'account/contents', component: _containers.MyContents })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _containers.About }),
    _react2.default.createElement(_reactRouter.Route, { path: 'profile/:id', component: _containers.Profile }),
    _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.Login }),
    _react2.default.createElement(_reactRouter.Route, { path: 'survey', component: _containers.Survey }),
    _react2.default.createElement(_reactRouter.Route, { path: 'widgets', component: _containers.Widgets }),
    _react2.default.createElement(_reactRouter.Route, { path: 'content/create', component: _containers.ContentEditor }),
    _react2.default.createElement(_reactRouter.Route, { path: 'content/:id/edit', component: _containers.ContentEditor }),
    _react2.default.createElement(_reactRouter.Route, { path: 'lessons', component: _containers.Lessons }),
    _react2.default.createElement(_reactRouter.Route, { path: 'homedev', component: _containers.HomeDev }),
    _react2.default.createElement(_reactRouter.Route, { path: 'lesson/create', component: _containers.CreateLesson }),
    _react2.default.createElement(_reactRouter.Route, { path: 'course/:courseId/createLesson', component: _containers.CreateLesson }),
    _react2.default.createElement(_reactRouter.Route, { path: 'lesson/:id', component: _containers.Lesson }),
    _react2.default.createElement(_reactRouter.Route, { path: 'lesson/:id/edit', component: _containers.LessonEditor }),
    _react2.default.createElement(_reactRouter.Route, { path: 'page/:id', component: _containers.ContentPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'contentNoLesson/:id', component: _containers.ContentPageNoLesson }),
    _react2.default.createElement(_reactRouter.Route, { path: 'course/:id', component: _containers.Course }),
    _react2.default.createElement(_reactRouter.Route, { path: 'knowledge/editor/:page', component: _containers.KnowledgeEditor }),
    _react2.default.createElement(_reactRouter.Route, { path: 'translate/:word/:langType/:targetLang', component: _containers.Translation }),
    _react2.default.createElement(_reactRouter.Route, { path: 'dict/:langType/:word', component: _containers.RedirectComponent }),
    _react2.default.createElement(_reactRouter.Route, { path: 'newKnowledgeWithAShortSumary/:langType/:word', component: _containers.RedirectComponent }),
    _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _containers.Account }),
    _react2.default.createElement(_reactRouter.Route, { path: 'admin', component: _containers.Admin }),
    _react2.default.createElement(_reactRouter.Route, { path: ':language', component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: ':language/translate/:word/:langType', component: _containers.Translation }),
    _react2.default.createElement(_reactRouter.Route, { path: ':language/knowledge/:page', component: _containers.Knowledge }),
    _react2.default.createElement(_reactRouter.Route, { path: ':language/sentences/:page', component: _containers.Sentences }),
    _react2.default.createElement(_reactRouter.Route, { path: ':language/content/:id', component: _containers.Content }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1551
// module chunks = 0